<template>
  <transition name="fade">
    <div v-if="visible" class="status-message" :class="type">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'StatusMessage',
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['success', 'info', 'warning', 'error'].includes(value)
    },
    duration: {
      type: Number,
      default: 3000
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.duration > 0) {
        setTimeout(() => {
          this.$emit('update:visible', false);
        }, this.duration);
      }
    }
  }
};
</script>

<style scoped>
.status-message {
  position: fixed;
  bottom: 10px;
  right: 10px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  max-width: 80%;
  word-wrap: break-word;
}

.status-message.success {
  background-color: #4caf50;
}

.status-message.info {
  background-color: #2196f3;
}

.status-message.warning {
  background-color: #ff9800;
}

.status-message.error {
  background-color: #f44336;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style> 